import React from "react";

export default function SubTotalLabel({ total }) {
  return (
    <p>
      Subtotal <span className="float-right">AU ${total.toFixed(2)}</span>
    </p>
  );
}
